(function () {
  var DEBOUNCE_MS = 280;
  var MIN_LENGTH = 2;
  var initialized = false;

  var initPredictiveSearch = function () {
    if (initialized) {
      return;
    }

    var searchRoot = document.getElementById("Search");

    if (!searchRoot || !searchRoot.hasAttribute("data-search-predictive")) {
      return;
    }

    initialized = true;

    var input = searchRoot.querySelector("[data-search-predictive-input], [name='q']");
    var live = searchRoot.querySelector("[data-search-live]");
    var clearButton = searchRoot.querySelector("[data-search-clear]");
    var timer = 0;
    var abortController = null;
    var allowProgrammaticClose = false;

    if (!input || !live) {
      return;
    }

    var cancelRequest = function () {
      window.clearTimeout(timer);
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
    };

    var clearLive = function () {
      live.setAttribute("hidden", "");
      live.innerHTML = "";
      live.removeAttribute("aria-busy");
    };

    var updateClearButton = function () {
      if (!clearButton) {
        return;
      }

      if ((input.value || "").trim()) {
        clearButton.removeAttribute("hidden");
      } else {
        clearButton.setAttribute("hidden", "");
      }
    };

    var buildUrl = function (query) {
      var endpoint =
        searchRoot.getAttribute("data-predictive-search-url") ||
        (window.routes && window.routes.predictiveSearchUrl);

      if (!endpoint) {
        return null;
      }

      var url = new URL(endpoint, window.location.origin);
      url.searchParams.set("q", query);
      url.searchParams.set("resources[type]", "product,page,collection");
      url.searchParams.set("resources[limit]", "10");
      url.searchParams.set("resources[limit_scope]", "each");
      url.searchParams.set("resources[unavailable_products]", "hide");
      url.searchParams.set("section_id", "predictive-search");
      return url;
    };

    var renderLive = function (html) {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = html;
      var markup = wrapper.querySelector("[data-search-live-markup]");
      var markupHtml = markup ? markup.innerHTML.trim() : "";

      live.removeAttribute("aria-busy");

      if (!markupHtml) {
        live.innerHTML = '<p class="Search__Empty">No results could be found</p>';
        live.removeAttribute("hidden");
        return;
      }

      live.innerHTML = markupHtml;
      live.removeAttribute("hidden");
    };

    var requestResults = function (query) {
      var url = buildUrl(query);

      if (!url) {
        return;
      }

      if (abortController) {
        abortController.abort();
      }

      abortController = new AbortController();
      live.setAttribute("aria-busy", "true");

      fetch(url, { signal: abortController.signal })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Predictive search failed");
          }
          return response.text();
        })
        .then(function (html) {
          if (searchRoot.getAttribute("aria-hidden") === "true") {
            return;
          }
          renderLive(html);
        })
        .catch(function (error) {
          if (error.name === "AbortError") {
            return;
          }
          live.removeAttribute("aria-busy");
        });
    };

    var onQueryChange = function (value) {
      var query = (value || "").trim();

      cancelRequest();

      if (!query || query.length < MIN_LENGTH) {
        clearLive();
        updateClearButton();
        return;
      }

      updateClearButton();

      timer = window.setTimeout(function () {
        requestResults(query);
      }, DEBOUNCE_MS);
    };

    input.addEventListener(
      "input",
      function (event) {
        event.stopImmediatePropagation();
        onQueryChange(event.target.value);
      },
      true
    );

    input.addEventListener(
      "keydown",
      function (event) {
        if (event.key !== "Enter" && event.keyCode !== 13) {
          return;
        }

        event.stopImmediatePropagation();

        var query = (input.value || "").trim();
        var form = input.form;

        if (!query || !form) {
          event.preventDefault();
          return;
        }

        form.submit();
      },
      true
    );

    if (clearButton) {
      clearButton.addEventListener("click", function (event) {
        event.preventDefault();
        input.value = "";
        clearLive();
        updateClearButton();
        input.focus();
      });
    }

    clearLive();
    updateClearButton();

    var searchHome = searchRoot.parentNode;
    var searchMarker = document.createComment("predictive-search");

    var pinSearch = function () {
      if (searchRoot.parentNode === document.body) {
        return;
      }

      searchHome.insertBefore(searchMarker, searchRoot);
      document.body.appendChild(searchRoot);
    };

    var unpinSearch = function () {
      if (!searchMarker.parentNode) {
        return;
      }

      searchMarker.parentNode.insertBefore(searchRoot, searchMarker);
    };

    var closeThemeSearch = function () {
      var closeBtn = searchRoot.querySelector('[data-action="close-search"]');

      if (!closeBtn) {
        return;
      }

      allowProgrammaticClose = true;
      closeBtn.click();
      allowProgrammaticClose = false;
    };

    var hideGloboSearch = function () {
      document.documentElement.classList.remove("gl-filter-search-fullscreen");
      document.body.classList.remove("gl-filter-search-fullscreen");
      document.querySelectorAll(
        ".gl-fullscreen-layer, .gl-backdrop, .ui-widget-overlay, .gl-filter-search-fullscreen"
      ).forEach(function (el) {
        if (el === document.documentElement || el === document.body) {
          el.classList.remove("gl-filter-search-fullscreen");
          return;
        }

        el.style.setProperty("display", "none", "important");
        el.style.setProperty("pointer-events", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
      });
    };

    document.addEventListener(
      "click",
      function (event) {
        var close = event.target.closest && event.target.closest('[data-action="close-search"]');

        if (close && !event.isTrusted && !allowProgrammaticClose) {
          event.preventDefault();
          event.stopImmediatePropagation();
          hideGloboSearch();
          return;
        }

        if (event.target.closest && event.target.closest("#Search, .Search--predictive")) {
          hideGloboSearch();
          return;
        }

        if (
          event.isTrusted &&
          searchRoot.getAttribute("aria-hidden") === "false" &&
          !event.target.closest('[data-action="toggle-search"]') &&
          !event.target.closest('[data-action="open-search"]') &&
          !event.target.closest('[data-action="close-search"]')
        ) {
          closeThemeSearch();
          return;
        }

        var globoLayer =
          event.target.closest &&
          event.target.closest(".gl-fullscreen-layer, .gl-backdrop, .gl-filter-search-fullscreen, .ui-widget-overlay");

        if (!globoLayer || globoLayer === document.documentElement || globoLayer === document.body) {
          return;
        }

        hideGloboSearch();
      },
      true
    );

    window.addEventListener("globoFilterRenderSearchCompleted", function () {
      hideGloboSearch();

      window.setTimeout(function () {
        hideGloboSearch();
        if (searchRoot.getAttribute("aria-hidden") === "true") {
          var toggle = document.querySelector('[data-action="toggle-search"]');
          if (toggle) {
            toggle.click();
          }
        }
      }, 0);
    });

    new MutationObserver(function () {
      if (searchRoot.getAttribute("aria-hidden") === "false") {
        hideGloboSearch();
        pinSearch();
        onQueryChange(input.value);
      } else {
        cancelRequest();
        unpinSearch();
      }
    }).observe(searchRoot, { attributes: true, attributeFilter: ["aria-hidden"] });

    new MutationObserver(function () {
      if (searchRoot.getAttribute("aria-hidden") === "false") {
        hideGloboSearch();
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPredictiveSearch);
  } else {
    initPredictiveSearch();
  }
})();


// search JS ends




$(document).ready(function () {
  $(document).on("submit", ".ajax-add-to-cart-form", function (event) {
    event.preventDefault();
    var ID = $(this).find("#quantity").attr("value");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: ID,
        id: $(this).find('[name="id"]').attr("value"),
      },
      dataType: "json",
      success: function (data) {
        function updateCart() {
          console.log("this function is working PROPERLY");
          fetch("/cart/?view=drawer")
            .then((response) => response.text())
            .then((cartData) => {
              let parser = new DOMParser();
              htmlData = parser.parseFromString(cartData, "text/html");
              $("#sidebar-cart").html($(htmlData).find('#sidebar-cart').html());
            })
            .then(document.querySelector('[aria-label="Open cart"]').click());
        }
        updateCart();
        $("#CartCount span:first").text(data.quantity);
        console.log(data.quantity);
        
        
      },
    });
  });
});

